<template>
  <div>
    <PageTitle v-bind:title="'HCC Statistics'" />

    <b-container fluid="xxl" style="width: 100%;">

      <b-row>
        <b-col>
          <div id="selectAggMode">
            <div class=filSel>
              <Select2
                :options="['scripta', 'scriptorium', 'document', 'dees macro', 'dees micro', 'parameter']"
                ref="select2"
                v-model="preAggMode"
                style="width: 30%"
                tabindex="0"
              />
            </div>

            <div class=filSel>
              <input
                v-if="isNotDees()"
                v-model.lazy="aggFilter"
                type="text"
                placeholder="specify Aggregators (RegEx)"
              />
              <b-form-checkbox
                v-else
                v-model="plusSupplement"
                name="check-button"
                class="mb-4">
                plus supplement
              </b-form-checkbox>
              <b-form-checkbox
                v-if="preAggMode == 'dees macro'"
                v-model="macro86"
                name="check-button"
                style="margin-top: -20px;"
                class="mb-4">
                macro 86
              </b-form-checkbox>
            </div>

            <button class="btn btn-primary" :disabled="!preAggMode" @click="fetchJSONData">OK</button>
          </div>
        </b-col>
        <b-col>

          <div>
            <span
              v-if="fetchedData == 'document' || fetchedData == 'scriptorium'"
              v-html="`${this.lemonStr} Scriptorium`"
            />
            <div
              class=lemonDocs
              v-if="fetchedData == 'document' || fetchedData == 'scriptorium'"
            >
              <div
                v-for="doc in lemonDocs"
                :key="doc"
              >
                <ul>
                  <li v-html="doc"/>
                </ul>
              </div>

            </div>
            <span v-if="fetchedData == 'document'">
            <b-button
              class="btn btn-primary"
              @click="setLemons"
              style="margin-right: 5px;"
            >push</b-button>
            </span>

            <span v-if="fetchedData == 'document'">
            <b-button
              @click="clearLemons"
              type="submit"
              variant="danger"
              :disabled="lemonDocs.length == 0"
            >clear</b-button>
            </span>
          </div>
        </b-col>
      </b-row>

      <hr>

      <b-row>
        <b-col>
          <div>
            <div id="selectDisplayVal">
              <div class=filSel v-if="isNotDees()">
                <Select2
                  :options="['relTags', 'numDocs', 'numTags', 'all']"
                  ref="select2"
                  style="width: 20%;"
                  v-if="preAggMode !== 'parameter'"
                  v-model="displayVal"
                  @select="selectDisplayVal($event)"
                  tabindex="0"
                />
              </div>

              <div class=filSel>
                <input
                  v-model="rowFilter"
                  v-if="allTableData.length > 0"
                  type="text"
                  placeholder="filter Rows (RegEx)"
                  @input="triggerFilterData"
                />
              </div>

              <div class=filSel>
                <input
                  v-if="allTableData.length > 0"
                  type="text"
                  placeholder="filter Columns (RegEx)"
                  @input="triggerFilterData"
                />
              </div>

            </div>

            <div class="mb-2">
              <b-button variant="info" @click="downloadCsv" class="mr-1" :disabled="tableData.slice(1).length == 0">
                Download Table (.csv)
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div id="tableDiv">
            <table class="table" id="datatable-results" v-if="tableData.length > 1">
              <colgroup>
                <col
                  v-for="(_, index) in tableData[0]"
                  :key="index"
                  :class="index == 0 ? 'firstcol' : index % 2 == 1 ? 'color' : ''"
                />
              </colgroup>
              <thead>
                <tr class="headrow">
                  <th class="headcol">&nbsp;</th>
                  <th
                    v-for="(col, index) in tableData[0].slice(1)"
                    :key="index"
                    v-html="col"
                    class="col"
                    :style="aggMode == 'document' ? 'cursor: pointer;' : ''"
                    @click="colClick($event)"
                  >
                  </th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr
                  v-for="(row, rindex) in tableData.slice(1)"
                  :key="rindex"
                  @click="highlightRow($event)"
                  :id="rindex"
                >
                  <th
                    v-if="dataIsNotDees() && aggMode !== 'parameter'"
                    class="headcol"
                    style="font-weight: bold; white-space: pre-line;"
                  >
                    <router-link
                      :to="{
                        name: 'HCCDetails',
                        params: {
                          id: row[0][1]
                        },
                      }"
                      target="_blank"
                      v-html="row[0][0]"
                    />
                  </th>
                  <th
                    v-else-if="dataIsNotDees() && aggMode == 'parameter'"
                    class="headcol"
                    style="font-weight: bold; white-space: pre-line;"
                    v-html="row[0][0]"
                  />
                  <th
                    v-else
                    class="headcol"
                    style="font-weight: bold;"
                    v-html="`${row[0][0]}<span style='margin-left: 3em' /><sm>${row[0][1]}</sm>`"
                  />
                  <td
                    v-for="(vals, index) in row.slice(1)"
                    :key="index"
                    v-html="vals ? displayValsStr(vals) : ''"
                    class="col"
                    style="white-space: pre-line; text-align: center;"
                  >
                  </td>
                </tr>
              </tbody>
            </table>
            <span v-else-if="tableData.length == 1">Loading...</span>
            <span v-else>No data</span>
          </div>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>


<style scoped>
* >>> .small-title legend {
  font-size: 10px !important;
  text-transform: uppercase;
  color: #bbbbbb;
}

#tableDiv {
  overflow: scroll;
  height: 900px;
  text-align: left;
}

table {
  white-space: nowrap;
  font-family: sans-serif;
  font-size: small;
  table-layout: fixed;
}

table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
}

table tbody th {
  position: relative;
}

table thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
}

table tbody th {
  position: sticky;
  left: 0;
  z-index: 1;
  background: white;
}

* >>> sm {
  font-size: smaller;
}

.lemonDocs {
  list-style: none;
  list-style-position: outside;
  border: 2.5px solid #ced4da;
  border-radius: 5px;
  width: 400px;
  height: 200px !important;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
}

.lemonDocs li {
  margin-left: -7px;
  margin-bottom: -10px;
  border: 2.5px solid #ced4da;
  border-radius: 5px;
  background-color: whitesmoke;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lemonDocs li * {
  font-family: arial;
  overflow: hidden;
}

.tbody th {
  font-weight: normal;
}

.hlrow {
  background-color: gold;
}

.mt-custom-form {
  margin-top: 20px;
}

.scroll-vertical {
  height: 100vh;
  overflow-y: auto;
}

#showDisplayVal {
  margin-bottom: 20px;
}

#selectDisplayVal {
  width: 70%;
  margin-bottom: 20px;
  float: left;
}

.filSel {
  margin-bottom: 5px;
}

.col {
  width: 14.5em;
}

.headcol {
  width: 25em;
}

.color {
  background-color: antiquewhite;
}
</style>


<script>
import axios     from 'axios'
import PageTitle from "@/components/PageTitle.vue";
import config    from '@/config.js'

export default {
  name: "HCCStats",
  components: {
    PageTitle,
  },

  data() {
    return {
      jsonData: {},
      rowHeaders: [],
      lemonDocs: [],
      aggFilter: '',
      fetchedData: '',
      rowFilter: '',
      colFilter: '',
      displayVal: 'all',
      aggMode: '',
      preAggMode: '',
      allTableData: [],
      plusSupplement: false,
      macro86: false,
      tableData: [],
      activeRow: null,
      lemonStr:  '🍋',
      defaultSort: [
        'saint.',
        'poit.',
        'ang.-tour.',
        'Centre',
        'hbret.',
        'agn.',
        'norm.occ.',
        'norm.nord-occ.',
        'norm.sud-occ.',
        'norm.sept.',
        'norm.mérid.',
        'franc.',
        "fr.d'Orient",
        'pic.mérid.',
        'pic.or.',
        'pic.sept.',
        'pic.nord-or.',
        'wall.occ.',
        'wall.or.',
        'champ.',
        'champ.sept.',
        'champ.mérid.',
        'lorr.occ.',
        'lorr.sept.',
        'lorr.centr.',
        'lorr.mérid.',
        'frcomt.',
        'bourg.sept.',
        'bourg.',
        'bourg.mérid.',
        'frpr.sept.',
        'frpr.centr.',
        'frpr.mérid.',
        'dauph.or.',
        'prov.sept.',
        'prov.or.',
        'prov.occ.',
        'lang.sept.'
      ]

    };
  },

  watch: {
    activeRow() {
      this.sortRow()
    }
  },

  methods: {
    toCSV(table) {
      return table
        .map((row, i) => row.map((cell, j) => {
            // We remove blanks and check if the column contains
            // other whitespace,`,` or `"`.
            // In that case, we need to quote the column.
            if (i === 0 && j === 0) cell = "\n"
            cell = j == 0 ? this.removeHTML(cell[0]) : cell
            cell = cell ? typeof cell === 'object' ? this.displayValsStr(cell) : cell.replace(/#/g, ".") : ''
            cell = cell.split("\n").map(c => {
              if (c.replace(/ /g, '').match(/[\s,"]/)) {
                  return '"' + c.replace(/"/g, '""') + '"'
              }
              return c
            }).join(',')
            return cell
          }).join(',')
        )
        .join('\n');
    },
    downloadCsv() {
      let csvContent = "data:text/csv;charset=utf-8," + this.toCSV(this.tableData);
      let encodedUri = encodeURI(csvContent);
      let filename = `gallrom_export_${(new Date()).toISOString()}.csv`;
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    displayValsStr(vals) {
      let StrVal

      switch (this.displayVal) {
        case 'all':
          if (this.aggMode == 'parameter') {
            StrVal = `${vals.paramData}`
          } else {
            StrVal = `${vals.numTags} / ${vals.numDocs} (${vals.relTags}%)`
          }
          break
        case 'relTags':
          StrVal = `${vals.relTags}%`
          break
        case 'deesM':
          StrVal = vals.deesM ? `${vals.deesM}%` : null
          break
        default:
          StrVal = `${vals[this.displayVal]}`
          break
      }

      return StrVal
    },
    highlightRow(event) {
      let sortRow
      if (event.target.parentElement.tagName.toLowerCase() == 'tr') {
        sortRow = event.target.parentElement.id
        if (this.activeRow == sortRow) {
          this.removeHighlightRow()
          this.activeRow = null
        } else {
          this.removeHighlightRow()
          document.getElementById(sortRow).classList.add('hlrow')
          document.getElementById(sortRow).firstChild.classList.add('hlrow')
          this.activeRow = sortRow
        }
      }
    },
    sortRow() {
      const attr = this.displayVal == "all" ? "relTags" : this.displayVal
      let sortRow
      let sortIndices

      if (this.activeRow) {
        sortRow = this.tableData.slice(1)[this.activeRow].slice(1)
        sortIndices = this.sortIndices(sortRow, attr)
      } else {
        sortRow = this.tableData[0].slice(1)
        sortIndices = this.sortIndices(sortRow, null)
      }

      let newTableData = []
      this.tableData.map(row => {
        let head = [row[0]]
        let tail = row.slice(1)
        let newTail = sortIndices.map(i => tail[i])
        newTableData.push(head.concat(newTail))
      })
      this.tableData = newTableData
    },
    filterRowCols() {
      const rowRegex = new RegExp(this.rowFilter, 'i')
      const colRegex = new RegExp(this.colFilter, 'i')

      let header = this.allTableData[0]
      let body = this.allTableData.slice(1)

      let rowTableData = []
      rowTableData.push(header)
      if (this.dataIsNotDees()) {
        body.filter(row => (this.removeHTML(row[0][0])).match(rowRegex)).map(row => rowTableData.push(row))
      } else {
        body.filter(row => (row[0][0].toString()).match(rowRegex) || row[0][1].match(rowRegex)).map(row => rowTableData.push(row))
      }

      let valCols = [0]
      header.forEach((elem, i) => { if ((elem).toString().length > 0 && (elem).toString().match(colRegex)) { valCols.push(i) }})

      let colTableData = []
      rowTableData.map(row => {
        let newRow = []
        valCols.map(i => newRow.push(row[i]))
        colTableData.push(newRow)
      })

      if (colTableData.length > 1) {
        this.tableData = colTableData
      } else {
        this.tableData = []
      }
      this.removeHighlightRow()
      this.sortRow()
    },
    removeHighlightRow() {
      let hlrows = document.getElementsByClassName('hlrow')
      while (hlrows.length)
          hlrows[0].classList.remove('hlrow')
    },
    async fetchLemons() {
      await axios
          .get(config.apiUrl + '/scriptoriums/lemon')
          .then(response => {
            this.lemonDocs = response.data.documents
          })
    },
    async setLemons() {
      const documents = this.lemonDocs
      await axios
          .post(config.apiUrl + '/scriptoriums/lemonize', {documents})
    },
    fetchJSONData() {
      this.aggMode = this.preAggMode
      if (['scriptorium', 'document'].includes(this.aggMode) && this.aggFilter == '') {
        this.$bvModal.msgBoxConfirm('no aggregator pattern specified. this might take a while and even crash your browser. continue?').then(value => {
        if (value) {
          this.fetchJSONDataDB()
        }
      })
     } else {
        this.fetchJSONDataDB()
     }
    },
    fetchJSONDataDB() {
      this.tableData = [false]
      this.allTableData = []
      this.activeRow = null

      if (this.isNotDees()) {
        if (this.fetchedData.startsWith('dees')) {
          this.displayVal = 'all'
        }
      } else if (this.aggMode == 'parameter') {
        this.displayVal = 'all'
      } else {
        this.displayVal = 'deesM'
      }

      if (this.aggMode == 'document' || this.aggMode == 'scriptorium') {
        this.fetchLemons()
      }

      const aggMode = this.aggMode
      const aggFilter = this.aggFilter
      const plusSup = this.plusSupplement
      const macro86 = this.macro86
      axios
        .post(config.apiUrl + '/hccs/statistics', {aggMode, aggFilter, plusSup, macro86})
        .then(response => {
          let data = response.data
          let obj = data.stats
          let tempTableData = []

          if (data.aggregators) {
            let cols
            if (this.isNotDees()) {
              cols = data.aggregators.sort()
            } else {
              cols = data.aggregators.sort(this.numSort)
            }

            this.jsonData = obj


            if (this.isNotDees()) {
              this.rowHeaders = Object.keys(data.rows).sort()
            } else {
              this.rowHeaders = Object.keys(data.rows).sort(this.numSort)
            }

            tempTableData.push([''].concat(cols))

            for (let i = 0; i < this.rowHeaders.length; i++) {
              let elem = this.rowHeaders[i]
              let item = [elem, data.rows[elem]]
              let row = []
              let extrRow = obj[elem]

              cols.map(col => {
                if (extrRow) {
                  row.push(extrRow[col])
                } else {
                  row.push(null)
                }
              })

              tempTableData.push([item].concat(row))
            }
          }

          this.allTableData = tempTableData
          this.tableData = tempTableData
          this.sortRow()
          this.fetchedData = this.aggMode
          this.resetParams()

          if (this.aggMode == 'document') {
            this.renderLemonDocs()
          }

      })
    },
    sortIndices (data, attr) {
      let indices

      if (attr) {
        indices = Object.keys(data)
        indices.sort(function(indexA, indexB) {
          const a = data[indexA]
          const b = data[indexB]

            if (!a) {
                return 1
            }
            if (!b) {
                return -1
            }

            if (a[attr] === b[attr]) {
                return 0
            }

            return a[attr] < b[attr] ? 1 : -1
        })
      } else {
        let sortObj = []
        data.forEach((elem, i) => sortObj.push({'elem': elem, 'i': i}))

        if (this.aggMode == 'scripta' || this.aggMode == 'parameter') {
          // sort according to defaut sort order by Glessgen
          sortObj.sort((a, b) => this.defaultSort.indexOf(a.elem) - this.defaultSort.indexOf(b.elem))
        } else if (this.isNotDees()) {
          // sort alphabetically
          sortObj.sort((a, b) => { return (a.elem < b.elem) ? -1 : (a.elem > b.elem) ? 1 : 0; })

          if (this.aggMode == 'scriptorium') {
            // put lemon at first position
            // (this ofc only works if the lemon will be the last after sorting alphabetically)
            const last = sortObj.length - 1
            sortObj = [sortObj[last]].concat(sortObj.slice(0, last))
          }

        } else {
          // sort numerically (= for Dees maps)
          sortObj.sort((a, b) => a.elem - b.elem)
        }

        indices = sortObj.map(e => e.i)
      }

      return indices
    },
    selectDisplayVal(event) {
      this.displayVal = event.text
      this.removeHighlightRow()
    },
    onlyUnique(value, index, array) {
      return array.indexOf(value) === index
    },
    removeHTML(s) {
      if (s) {
        return s.replace(/<[^>]+>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
      } else {
        return s
      }
    },
    numSort(a, b) {
      return a - b;
    },
    isNotDees() {
      return !this.preAggMode.startsWith('dees')
    },
    dataIsNotDees() {
      return !this.fetchedData.startsWith('dees')
    },
    resetParams() {
      this.rowFilter = ''
      this.colFilter = ''
      // this.aggFilter = ''
      if (this.isNotDees()) {
        this.plusSupplement = false
      }
    },
    triggerFilterData() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.filterRowCols()
      }, 300);
    },
    renderLemonDocs() {
      let newCols

      this.lemonDocs.map(ldoc => {
        newCols = this.tableData[0].map(e => e == ldoc ? e + this.lemonStr : e)
        this.tableData = [newCols].concat(this.tableData.slice(1))
        newCols = this.allTableData[0].map(e => e == ldoc ? e + this.lemonStr : e)
        this.allTableData = [newCols].concat(this.allTableData.slice(1))
      })
    },
    formatCols(str, unset) {
      [this.tableData, this.allTableData].map((collection, i) => {
        const head = collection[0]
        const body = collection.slice(1)
        let newCols

        if (str) {
          if (unset) {
            newCols = head.map(elem => elem == str ? elem.slice(0, elem.length-2) : elem )
          } else {
            newCols = head.map(elem => elem == str ? elem + this.lemonStr : elem )
          }
        } else {
          newCols = head.map(elem => elem.endsWith(this.lemonStr) ? elem.slice(0, elem.length-2) : elem )
        }

        i == 0 ? this.tableData = [newCols].concat(body) : this.allTableData = [newCols].concat(body)
      })
    },
    colClick(event) {
      if (this.aggMode == 'document') {

        const toLem = event.target.innerHTML

        if (toLem.endsWith(this.lemonStr)) {
          this.lemonDocs = this.lemonDocs.filter(e => e !== toLem.slice(0, toLem.length-2))
          this.lemonDocs.sort()

          this.formatCols(toLem, true)
        } else {
          this.lemonDocs.push(toLem)
          this.lemonDocs.sort()

          this.formatCols(toLem, false)
        }
      }
    },
    clearLemons() {
      this.$bvModal.msgBoxConfirm(`clear ${this.lemonStr} scriptorium?`).then(value => {
        if (value) {
          this.lemonDocs = []

          this.formatCols(false)

          axios
            .get(config.apiUrl + '/scriptoriums/delemonize')
        }
      })
    }

  }
};
</script>

